import React from 'react'

export default function body() {
  return (
    <div>body</div>
  )
}
